'use client';

import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import InitialLoading from '@/components/ui/InitialLoading';

export default function ConditionalLoading({
    children,
}: {
    children: React.ReactNode;
}) {
    const { isLoading } = useAuth();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    // Se estiver carregando a autenticação inicial, mostra o loading screen
    if (isLoading && mounted) {
        return <InitialLoading />;
    }

    // Se ainda não montou, já pinta o fundo escuro para evitar flash branco
    if (!mounted) {
        return <div className="min-h-screen bg-[#0a0a0a]" aria-hidden="true" />;
    }

    return <>{children}</>;
}
